import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form, Field } from 'redux-form';

import { SelectField } from 'common/components/forms';
// eslint-disable-next-line import/no-cycle
import { Modal, FormError } from 'common/components/layout';
import { integerFormat } from 'common/helpers/numberHelper';
import { editClubMembership } from 'redux/clubMemberships/actions';

import { validateFrequencyUpdate } from './validators';

class EditFrequencyModal extends Component {
  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);
    const successFunction = () => {
      props.onCloseModal();
    };
    props.editClubMembership(props.clubMembership.id, data, successFunction);
  };

  handleClose = (e) => {
    const { props } = this;
    e.preventDefault();
    props.onCloseModal();
  };

  render() {
    const { clubMembership, handleSubmit, form, onCloseModal } = this.props;
    const { frequenciesOffered } = clubMembership.club.subscription;
    return (
      <Modal
        className="c7-modal__content--add-hold"
        title="Change your Subscription Frequency"
        onCloseModal={onCloseModal}
        formName={form}
      >
        <FormError formName={form} />
        <Form
          onSubmit={handleSubmit(this.handleSubmit)}
          className="c7-form"
          method="post"
        >
          <Field
            name="frequency"
            component={SelectField}
            label="Shipment Frequency"
            optionArray={frequencyOptionArray(frequenciesOffered)}
            required
          />
          <div className="c7-form__button-row">
            <a onClick={this.handleClose} className="c7-button-alt">
              Cancel
            </a>
            <button type="submit" className="c7-button">
              Save Frequency
            </button>
          </div>
        </Form>
      </Modal>
    );
  }
}

const transformData = (values) => {
  const data = {
    subscription: {
      frequency: integerFormat(values.frequency)
    }
  };
  return data;
};

const validate = (values, ownProps) => {
  const data = transformData(values);
  const { frequenciesOffered } = ownProps.clubMembership.club.subscription;
  const errors = validateFrequencyUpdate(data, frequenciesOffered);
  return errors;
};

const mapStateToProps = (state, ownProps) => {
  const { clubMembership } = ownProps;
  return {
    initialValues: {
      frequency: clubMembership.subscription.frequency
    }
  };
};

const frequencyOptionArray = (frequencies) => {
  const array = [];
  frequencies.forEach((frequency) => {
    const option =
      frequency === 1 ? 'Every Month' : `Every ${frequency} Months`;
    array.push({ option, value: frequency });
  });
  return array;
};

EditFrequencyModal = reduxForm({
  form: 'EditFrequencyModal',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(EditFrequencyModal);

export default connect(mapStateToProps, {
  editClubMembership
})(EditFrequencyModal);
